<template>
  <div>
    <c-tab
      type="tabcard"
      align="left"
      :inlineLabel="true"
      :tabItems="tabItems"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :searchParam.sync="searchParam"
          :tabParam.sync="tabParam"
          :proceedingsTypeCd="tab.proceedingsTypeCd"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
// import selectConfig from '@/js/selectConfig';
export default {
  name: 'proceedings',
  data() {
    return {
      searchParam: {
        plantCd: '',
        proceedingsTypeCd: null,
        committeeTypeCd: '1',
        startYmd: '',
        endYmd: '',
      },
      period: [],
      editable: true,
      tab: '1',
      tabItems: [
        { name: '1', icon: 'folder', label: '본안', component: () => import(`${'./proceedingsMainAgenda.vue'}`), proceedingsTypeCd: 'SPA0000001' },
        { name: '2', icon: 'folder', label: '실무안', component: () => import(`${'./proceedingsWorkingPlan.vue'}`), proceedingsTypeCd: 'SPA0000005' },
      ],
      tabParam: {
        committeeTypeCd: '1',
        title: '본안', 
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      // code setting
      // list setting 
    },
    tabClick(tab) {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.searchParam.committeeTypeCd = tab.name;
      this.tabParam.committeeTypeCd = tab.name;
      this.tabParam.title = tab.label;
    }
  }
};
</script>
